// Types
import { IContactRecord, IContactRow } from '../../../types';

export const transformContactRecord = (contactRecord: IContactRecord): IContactRow => {
    return {
        id: contactRecord._id,
        portfolId: contactRecord.portfolId,
        name: contactRecord.name.fullName || '',
        email: contactRecord.email.primary,
        phone:
            contactRecord.phone?.primary?.areaCode && contactRecord.phone?.primary?.number
                ? `${contactRecord.phone.primary.areaCode}${contactRecord.phone.primary.number}`
                : '',
        isOkayToContact: contactRecord.isOkayToContact,
        gender: contactRecord.demographics.gender || '',
        race: contactRecord.demographics.raceEthnicity || [],
        organization: {
            id: contactRecord.organization._id,
            name: contactRecord.organization.name
        }
    };
};

export const transformContactRecordToForm = (contactRecord: IContactRecord) => ({
    CON0001: contactRecord?.name?.first,
    CON0002: contactRecord?.name?.middleInitial,
    CON0003: contactRecord?.name?.last,
    CON0005: contactRecord?.email?.primary,
    CON0006: contactRecord?.email?.secondary,
    CON0007: contactRecord?.phone?.primary,
    CON0008: contactRecord?.phone?.home,
    CON0009: contactRecord?.phone?.mobile,
    CON0011: contactRecord?.demographics?.gender,
    CON0013: contactRecord?.demographics?.raceEthnicity,
    CON0016: contactRecord?.isOkayToContact,
    CON0017: contactRecord?.demographics?.isDisabled,
    CON0018: contactRecord?.demographics?.isVeteran,
    CON0019: contactRecord?.jobTitle,
    CON0020: contactRecord?.percentOwnership,
    CON0022: contactRecord?.name?.suffix,
    CON0023: contactRecord?.name?.honorific,
    CON0024: contactRecord?.name?.pronouns
});
